import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { faPaperPlane, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import mainAxios from '../../../services/mainAxios';
import { toast } from 'react-toastify';

const SendNotificationModal = ({ user, socketRef, onSuccess }) => {
  const { t } = useTranslation('translations');
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    startDate: null,
    endDate: null,
    message: ""
  });

  const sendNotification = (e) => {
    e.preventDefault();
    const { message, startDate, endDate } = state;

    if (!message) {
      toast.error(t('common.requiredField'), { containerId: "all_toast" });
      return;
    }

    setLoading(true);
    mainAxios.post("/notifications/save", { text: message, startDate, endDate })
      .then(res => {
        if (res) {
          toast.success(t('notification.sent'), { containerId: "all_toast" });
          if (onSuccess) onSuccess();
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const handleChange = (key, value) => {
    setState((state) => ({ ...state, [key]: value }));
  };

  const refreshUsersPage = () => {
    if (socketRef) {
      socketRef.send('/topic/refresh', {}, JSON.stringify({
        name: user.username,
        message: "Refresh"
      }));
      toast.success('Refresh signal sent', { containerId: "all_toast" });
    }
  };

  return (
    <form onSubmit={sendNotification}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{t('common.startDate')}</label>
            <DatePicker
              selected={state?.startDate ? new Date(state?.startDate) : null}
              onChange={date => handleChange("startDate", date ? moment(date).format('YYYY-MM-DDTHH:mm:ss') : "")}
              dateFormat="dd/MM/yyyy HH:mm"
              showTimeSelect
              timeIntervals={15}
              timeCaption={t('common.time', 'Time')}
              className="form-control"
              timeFormat="HH:mm"
              placeholderText={t('common.selectDate')}
              popperProps={{ strategy: "fixed" }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{t('common.endDate')}</label>
            <DatePicker
              selected={state?.endDate ? new Date(state?.endDate) : null}
              onChange={date => handleChange("endDate", date ? moment(date).format('YYYY-MM-DDTHH:mm:ss') : "")}
              dateFormat="dd/MM/yyyy HH:mm"
              showTimeSelect
              timeIntervals={15}
              timeCaption={t('common.time', 'Time')}
              className="form-control"
              timeFormat="HH:mm"
              placeholderText={t('common.selectDate')}
              popperProps={{ strategy: "fixed" }}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label>{t('notification.message')}<span className="text-danger"> *</span></label>
            <textarea
              className="form-control"
              value={state?.message ?? ""}
              onChange={(e) => handleChange("message", e.target.value)}
              rows="5"
              placeholder={t('notification.messagePlaceholder')}
            />
          </div>
        </div>
      </div>
      <div className="mt-3 d-flex gap-2">
        <button className="btn btn-primary" type="submit" disabled={loading}>
          <FontAwesomeIcon icon={faPaperPlane} className="mr-2" />
          {t('invoice.send')}
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary ml-2"
          onClick={refreshUsersPage}
        >
          <FontAwesomeIcon icon={faSyncAlt} className="mr-2" />
          Refresh Users
        </button>
      </div>
    </form>
  );
};

export default SendNotificationModal;
